import React, { useEffect, useState } from 'react';
import api from '../api';
import styled from 'styled-components';

const ImageContainer = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`;

const StyledImage = styled.img`
  width: 100%;
  height: auto;
  max-height: 400px;
  object-fit: contain;
  border-radius: 4px;
`;

const ErrorMessage = styled.p`
  color: #ff0000;
  text-align: center;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`;

const LoadingMessage = styled.p`
  text-align: center;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`;

const ImageViewer = ({ nomeArquivo, idRede, timestamp }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_69;
  const [imageUrl, setImageUrl] = useState('');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let objectUrl;

    const fetchImage = async () => {
      setLoading(true);
      setError(false);
      
      try {
        if (!apiUrl) {
          console.error('REACT_APP_API_BASE_69 não está definida.');
          setError(true);
          return;
        }

        if (!nomeArquivo || !idRede) {
          console.error('Nome do arquivo ou ID da rede não fornecidos.');
          setError(true);
          return;
        }

        const response = await api.get(`${apiUrl}/${nomeArquivo}?id_rede=${idRede}`, {
          responseType: 'blob',
        });

        if (!response.data) {
          throw new Error('Resposta vazia do servidor');
        }

        objectUrl = URL.createObjectURL(response.data);
        setImageUrl(objectUrl);
      } catch (err) {
        console.error('Erro ao carregar imagem:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchImage();

    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [nomeArquivo, idRede, apiUrl, timestamp]);

  if (loading) {
    return (
      <ImageContainer>
        <LoadingMessage>Carregando imagem...</LoadingMessage>
      </ImageContainer>
    );
  }

  if (error) {
    return (
      <ImageContainer>
        <ErrorMessage>
          Erro ao carregar a imagem. Por favor, verifique se o arquivo existe e tente novamente.
        </ErrorMessage>
      </ImageContainer>
    );
  }

  return (
    <ImageContainer>
      {imageUrl && (
        <StyledImage
          src={imageUrl}
          alt={`Imagem ${nomeArquivo}`}
          onError={(e) => {
            e.target.src = 'https://via.placeholder.com/300?text=Imagem+não+encontrada';
            e.target.alt = 'Imagem não encontrada';
            setError(true);
          }}
        />
      )}
    </ImageContainer>
  );
};

export default ImageViewer;
